import { useEffect, useState } from "react";
import ApiClient from "../../methods/api/apiClient";
import loader from "../../methods/loader";
import Html from "./html";
import { useNavigate } from "react-router-dom";

const Transactions = () => {
  const searchState = { data: "" };
  const navigate = useNavigate();
  const [filters, setFilter] = useState({ page: 1, count: 10, search: "", status: "" });
  const [data, setData] = useState([]);
  const [total, setTotal] = useState(0);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  useEffect(() => {
    setFilter({ ...filters, search: searchState.data });
    getData({ search: searchState.data });
  }, []);

  const getData = (p = {}) => {
    loader(true);
    let filter = { ...filters, ...p };
    ApiClient.get("transactions/list", filter).then((res) => {
      if (res.success) {
        setData(res?.data);
        setTotal(res?.total);
      }
      loader(false);
    });
  };

  const clear = () => {
    let f = { search: "", transaction_status: "" };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const filter = (p = {}) => {
    let f = { ...p };
    setFilter({ ...filters, ...f });
    getData({ ...f });
  };

  const pageChange = (e) => {
    setFilter({ ...filters, page: e });
    getData({ page: e });
  };

  const count = (e) => {
    setFilter({ ...filters, count: e });
    getData({ ...filters, count: e });
  };

  const handleSearch = (e) => {
    setFilter({ ...filters, search: e.target.value });
    if (e.target.value === "") {
      getData({ search: "" });
    }
  };

  const changestatus = (e, key) => {
    setFilter({ ...filters, [key]: e });
    getData({ [key]: e });
  }

  const view=(id)=>{
    navigate(`/transaction/detail/${id}`);
  }

  return (
    <>
      <Html
        clear={clear}
        count={count}
        pageChange={pageChange}
        filters={filters}
        setFilter={setFilter}
        filter={filter}
        data={data}
        total={total}
        handleSearch={handleSearch}
        changestatus={changestatus}
        view={view}
        setDateRange={setDateRange}
        getData={getData}
        startDate={startDate}
        endDate={endDate}
      />
    </>
  );
};

export default Transactions;